/**
 * Painel "Pesquisar com IA" — sugestões cadastradas no ERP para vínculo.
 */
import React, { useMemo } from 'react';
import { GoHoverTooltip } from '../../go-config/components/GoHoverTooltip';

function AiNameCell({ title, subtitle, tip, badge }) {
  return (
    <span className="vp-mock-catalog-cell vp-mock-catalog-cell--name vp-mock-catalog-ai-name">
      <GoHoverTooltip text={tip || title} onlyWhenTruncated={!subtitle} wrap align="start">
        <span className="vp-mock-catalog-ai-name-stack">
          <span className="vp-mock-catalog-name go-dev-ellipsis">{title}</span>
          {subtitle ? <span className="vp-mock-catalog-ai-sub go-dev-ellipsis">{subtitle}</span> : null}
        </span>
      </GoHoverTooltip>
      {badge || null}
    </span>
  );
}

export default function CompatCatalogAiPanel({
  loading,
  error,
  result,
  selected,
  linkedSet,
  allowedProductCodes = null,
  onToggle,
  onBack,
}) {
  const inCatalog = useMemo(() => {
    const rows = result?.inCatalog || [];
    const base = !allowedProductCodes
      ? rows
      : rows.filter((p) => p.erpProductCode && allowedProductCodes.has(p.erpProductCode));
    return base.filter((p) => p.erpProductCode && !linkedSet.has(p.erpProductCode));
  }, [result, allowedProductCodes, linkedSet]);

  const summary = result?.summary;
  const summaryInCatalog = inCatalog.length;

  return (
    <div className="vp-mock-catalog-ai">
      <div className="vp-mock-catalog-ai-toolbar">
        <button type="button" className="user-form-link-btn user-form-footer-btn" onClick={onBack}>
          Voltar ao catálogo
        </button>
        {summary ? (
          <span className="vp-mock-catalog-ai-summary">
            {summaryInCatalog} no cadastro para vincular
            {result?.usedAi ? ' · Orya' : ''}
          </span>
        ) : null}
      </div>

      {loading ? (
        <div className="vp-mock-catalog-empty">Consultando catálogo e gerando nomes amigáveis com Orya…</div>
      ) : null}
      {!loading && error ? <div className="vp-mock-catalog-empty is-error">{error}</div> : null}

      {!loading && !error && result ? (
        <div className="vp-mock-catalog-ai-body">
          <div className="vp-mock-catalog-ai-section-label">Sugestões cadastradas</div>
          {inCatalog.length === 0 ? (
            <div className="vp-mock-catalog-ai-hint">
              Nenhuma peça do canônico encontrada no cadastro permitido para este modelo.
            </div>
          ) : (
            <div className="vp-mock-catalog-table-wrap vp-mock-catalog-ai-table">
              <div className="vp-mock-catalog-table vp-mock-catalog-table--ai" role="table">
                <div className="vp-mock-catalog-thead" role="row">
                  <span>Peça</span>
                  <span>Tipo</span>
                  <span>Fabricante</span>
                  <span>Part number</span>
                  <span className="vp-mock-catalog-th--end">Status</span>
                </div>
                {inCatalog.map((p) => {
                  const code = p.erpProductCode;
                  const on = selected.includes(code);
                  const title = p.displayName || p.friendlyName || p.erpName || p.name;
                  const tip = [p.friendlyNote, p.name].filter(Boolean).join('\n\n');
                  return (
                    <div
                      key={`in-${p.canonicalId}-${code}`}
                      role="row"
                      className={'vp-mock-catalog-row' + (on ? ' is-selected' : '')}
                      onClick={() => onToggle(code)}
                    >
                      <AiNameCell title={title} subtitle={p.friendlyNote || null} tip={tip} />
                      <span className="vp-mock-catalog-cell">{p.typeLabel || '—'}</span>
                      <span className="vp-mock-catalog-cell">{p.erpBrand || p.brandName}</span>
                      <span className="vp-mock-catalog-cell vp-mock-catalog-cell--mono">
                        {p.displayPart || p.primaryPart || p.partNumber}
                      </span>
                      <span className="vp-mock-catalog-cell vp-mock-catalog-cell--end">
                        <span className="vp-mock-catalog-ai-badge is-in">No cadastro</span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
